export const COLOR_MODE_STORAGE_KEY = "research-app-color-mode";

export type ColorMode = "light" | "dark" | "system";

export const COLOR_MODE_CYCLE: ColorMode[] = ["system", "light", "dark"];

const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export function isColorMode(value: string | null | undefined): value is ColorMode {
  return value === "light" || value === "dark" || value === "system";
}

export function parseColorMode(value: string | null | undefined): ColorMode {
  return isColorMode(value) ? value : "system";
}

export function nextColorMode(current: ColorMode): ColorMode {
  const index = COLOR_MODE_CYCLE.indexOf(current);
  const next = index === -1 ? 0 : (index + 1) % COLOR_MODE_CYCLE.length;
  return COLOR_MODE_CYCLE[next] ?? "system";
}

export function readStoredColorMode(): ColorMode {
  if (typeof window === "undefined") return "system";

  try {
    const stored = localStorage.getItem(COLOR_MODE_STORAGE_KEY);
    return parseColorMode(stored);
  } catch {
    return "system";
  }
}

export function applyColorModeToDocument(mode: ColorMode): void {
  if (typeof document === "undefined") return;

  if (mode === "light" || mode === "dark") {
    document.documentElement.setAttribute("data-theme", mode);
    return;
  }

  document.documentElement.removeAttribute("data-theme");
}

export function storeColorMode(mode: ColorMode): void {
  try {
    localStorage.setItem(COLOR_MODE_STORAGE_KEY, mode);
  } catch {
    // ignore quota / private mode
  }

  try {
    document.cookie = `${COLOR_MODE_STORAGE_KEY}=${mode};path=/;max-age=${COOKIE_MAX_AGE_SECONDS};samesite=lax`;
  } catch {
    // ignore
  }

  applyColorModeToDocument(mode);
}

export function resolveColorModeForHtml(
  mode: ColorMode,
): "light" | "dark" | undefined {
  return mode === "light" || mode === "dark" ? mode : undefined;
}

/** Блокирующий скрипт в layout — до React, без отдельного компонента. */
export const COLOR_MODE_BOOTSTRAP_SCRIPT = `(function(){try{var k=${JSON.stringify(COLOR_MODE_STORAGE_KEY)};var m=localStorage.getItem(k);if(m==="light"||m==="dark"){document.documentElement.setAttribute("data-theme",m);document.cookie=k+"="+m+";path=/;max-age=31536000;samesite=lax";}}catch(e){}})();`;
